import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '../../../../styles/styled';
import { hideVisually, navigationItem } from '../../../../styles/style-mixins';
import { useClickEvent } from '../../../../hooks/useClickEvent';
import Body from '../../../Body';
import { useComponents } from '../../../ComponentsContext';
import { Skeleton } from '../../../Skeleton';
const anchorStyles = ({ theme }) => css `
  text-decoration: none;
  height: 100%;
  padding: 0 ${theme.spacings.mega};
  border-left: ${theme.borderWidth.kilo} solid ${theme.colors.n300};
`;
const UtilityAnchor = styled.a(navigationItem, anchorStyles);
const iconStyles = (theme) => css `
  flex-shrink: 0;
  width: ${theme.iconSizes.mega};
  height: ${theme.iconSizes.mega};

  ${theme.mq.kilo} {
    margin-right: ${theme.spacings.byte};
  }
`;
const labelStyles = ({ theme }) => css `
  ${theme.mq.untilKilo} {
    ${hideVisually()};
  }
`;
const UtilityLabel = styled(Body)(labelStyles);
function UtilityLink({ icon: Icon, label, onClick, tracking, ...props }) {
    const components = useComponents();
    const Link = components.Link;
    const handleClick = useClickEvent(onClick, tracking, 'utility-link');
    return (_jsxs(UtilityAnchor, { ...props, onClick: handleClick, as: props.href ? Link : 'button', children: [_jsx(Skeleton, { css: iconStyles, children: _jsx(Icon, { role: "presentation", size: "24" }, void 0) }, void 0), _jsx(Skeleton, { children: _jsx(UtilityLabel, { variant: props.isActive ? 'highlight' : undefined, noMargin: true, as: "span", children: label }, void 0) }, void 0)] }, void 0));
}
const UtilityLinksWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export function UtilityLinks({ links }) {
    return (_jsx(UtilityLinksWrapper, { children: links.map((link) => (_jsx(UtilityLink, { ...link }, link.label))) }, void 0));
}
